export const companyConstants = {
  CREATE_COMPANY: "CREATE_COMPANY",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  GET_COMPANY: "GET_COMPANYS",
  GET_COMPANY_BY_ID: "GET_COMPANY_BY_ID",
  DELETE_COMPANY: "DELETE_COMPANY",
  GET_COMPANY_LIST: "GET_COMPANY_LIST",
};
